import api from '../common/helpers/apiHelper';
import { IQuestionWithOwner } from '../common/models/question/IQuestionWithOwner';
import { IQuestionText } from '../common/models/question/IQuestionText';

export const getQuestions = (payload: boolean) => api.get<IQuestionWithOwner[]>(
  '/api/questions',
  { isRatingScale: payload }
);

export const createQuestion = (payload: string) => api.post<IQuestionWithOwner>(
  '/api/questions',
  { text: payload }
);

export const updateQuestion = ({ id, text }: IQuestionText) => api.put<IQuestionText>(
  `/api/questions/${id}`,
  { text }
);

export const deleteQuestion = (id: IQuestionText) => api.delete(
  `/api/questions/${id}`
);
